export const translations = {
  en: {
    dashboard: 'Dashboard',
    taxReports: 'Tax Reports',
    settings: 'Settings',
    logout: 'Logout',
    superAdmin: 'Super Admin',
    teamLeader: 'Team Leader',
    normalUser: 'Normal User',
    receipts: 'Receipts',
    users: 'Users',
    businesses: 'Businesses',
    payments: 'Payments',
    systemLogs: 'System Logs',
    botManagement: 'Bot Management',
    totalReceipts: 'Total Receipts',
    totalAmount: 'Total Amount',
    pendingReview: 'Pending Review',
    verified: 'Verified',
    recentReceipts: 'Recent Receipts',
    merchant: 'Merchant',
    date: 'Date',
    amount: 'Amount',
    status: 'Status',
    actions: 'Actions',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    profileSettings: 'Profile Settings',
    darkMode: 'Dark Mode',
    language: 'Language',
    save: 'Save',
    cancel: 'Cancel',
    handsFree: 'Hands Free',
    sendMessage: 'Send Message',
    taxCenter: 'Tax Center',
    verifiedReportingManaged: 'Verified reporting managed by Lyt Brox Pte Ltd.',
    exportIRASSummary: 'Export IRAS Summary',
    fiscalEnvironment: 'Fiscal Environment',
    financialYear: 'Financial Year',
    totalVerifiedBusinessDeductions: 'Total Verified Business Deductions',
    totalInputTax: 'Total Input Tax (GST)',
    eligibleRecords: 'Eligible Records',
    complianceVerified: 'COMPLIANCE VERIFIED',
    filingStatus: 'Filing Status',
    lytspeedAuditMessage: 'Lytspeed has audited your records against Singapore tax standards for Lyt Brox Pte Ltd.',
    taxRate: 'Tax Rate',
    dataIntegrity: 'Data Integrity',
    auditExport: 'AUDIT EXPORT',
    taxCategoryDistribution: 'Tax Category Distribution',
    deductible: 'Deductible',
    records: 'records',
    verifiedRecords: 'Verified Records',
    category: 'Category',
    noCategoriesFound: 'No categories found',
    noVerifiedRecordsFound: 'No verified records found for',
    searchVerifiedRecords: 'Search verified records...',
  },
  zh: {
    dashboard: '仪表板',
    taxReports: '税务报告',
    settings: '设置',
    logout: '登出',
    superAdmin: '超级管理员',
    teamLeader: '团队负责人',
    normalUser: '普通用户',
    receipts: '收据',
    users: '用户',
    businesses: '企业',
    payments: '支付',
    systemLogs: '系统日志',
    botManagement: '机器人管理',
    totalReceipts: '总收据',
    totalAmount: '总金额',
    pendingReview: '待审核',
    verified: '已验证',
    recentReceipts: '最近收据',
    merchant: '商家',
    date: '日期',
    amount: '金额',
    status: '状态',
    actions: '操作',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    profileSettings: '个人资料设置',
    darkMode: '深色模式',
    language: '语言',
    save: '保存',
    cancel: '取消',
    handsFree: '免提',
    sendMessage: '发送消息',
    taxCenter: '税务中心',
    verifiedReportingManaged: '由 Lyt Brox Pte Ltd. 管理的经过验证的报告。',
    exportIRASSummary: '导出IRAS摘要',
    fiscalEnvironment: '财政环境',
    financialYear: '财政年度',
    totalVerifiedBusinessDeductions: '已验证的业务扣除总额',
    totalInputTax: '总进项税（消费税）',
    eligibleRecords: '符合条件的记录',
    complianceVerified: '合规已验证',
    filingStatus: '申报状态',
    lytspeedAuditMessage: 'Lytspeed 已根据新加坡税务标准为 Lyt Brox Pte Ltd. 审核了您的记录。',
    taxRate: '税率',
    dataIntegrity: '数据完整性',
    auditExport: '审计导出',
    taxCategoryDistribution: '税务类别分布',
    deductible: '可扣除',
    records: '记录',
    verifiedRecords: '已验证记录',
    category: '类别',
    noCategoriesFound: '未找到类别',
    noVerifiedRecordsFound: '未找到已验证记录',
    searchVerifiedRecords: '搜索已验证记录...',
  },
  ms: {
    dashboard: 'Papan Pemuka',
    taxReports: 'Laporan Cukai',
    settings: 'Tetapan',
    logout: 'Log Keluar',
    superAdmin: 'Super Admin',
    teamLeader: 'Ketua Pasukan',
    normalUser: 'Pengguna Biasa',
    receipts: 'Resit',
    users: 'Pengguna',
    businesses: 'Perniagaan',
    payments: 'Pembayaran',
    systemLogs: 'Log Sistem',
    botManagement: 'Pengurusan Bot',
    totalReceipts: 'Jumlah Resit',
    totalAmount: 'Jumlah Amaun',
    pendingReview: 'Menunggu Semakan',
    verified: 'Disahkan',
    recentReceipts: 'Resit Terkini',
    merchant: 'Pedagang',
    date: 'Tarikh',
    amount: 'Amaun',
    status: 'Status',
    actions: 'Tindakan',
    view: 'Lihat',
    edit: 'Edit',
    delete: 'Padam',
    profileSettings: 'Tetapan Profil',
    darkMode: 'Mod Gelap',
    language: 'Bahasa',
    save: 'Simpan',
    cancel: 'Batal',
    handsFree: 'Hands Free',
    sendMessage: 'Hantar Mesej',
    taxCenter: 'Pusat Cukai',
    verifiedReportingManaged: 'Pelaporan yang disahkan diuruskan oleh Lyt Brox Pte Ltd.',
    exportIRASSummary: 'Eksport Ringkasan IRAS',
    fiscalEnvironment: 'Persekitaran Fiskal',
    financialYear: 'Tahun Kewangan',
    totalVerifiedBusinessDeductions: 'Jumlah Potongan Perniagaan Yang Disahkan',
    totalInputTax: 'Jumlah Cukai Input (GST)',
    eligibleRecords: 'Rekod Layak',
    complianceVerified: 'PEMATUHAN DISAHKAN',
    filingStatus: 'Status Pemfailan',
    lytspeedAuditMessage: 'Lytspeed telah mengaudit rekod anda mengikut piawaian cukai Singapura untuk Lyt Brox Pte Ltd.',
    taxRate: 'Kadar Cukai',
    dataIntegrity: 'Integriti Data',
    auditExport: 'EKSPORT AUDIT',
    taxCategoryDistribution: 'Pengedaran Kategori Cukai',
    deductible: 'Boleh Ditolak',
    records: 'rekod',
    verifiedRecords: 'Rekod Yang Disahkan',
    category: 'Kategori',
    noCategoriesFound: 'Tiada kategori dijumpai',
    noVerifiedRecordsFound: 'Tiada rekod yang disahkan dijumpai untuk',
    searchVerifiedRecords: 'Cari rekod yang disahkan...',
  },
  ta: {
    dashboard: 'டாஷ்போர்டு',
    taxReports: 'வரி அறிக்கைகள்',
    settings: 'அமைப்புகள்',
    logout: 'வெளியேறு',
    superAdmin: 'சூப்பர் நிர்வாகி',
    teamLeader: 'குழு தலைவர்',
    normalUser: 'சாதாரண பயனர்',
    receipts: 'ரசீதுகள்',
    users: 'பயனர்கள்',
    businesses: 'வணிகங்கள்',
    payments: 'கட்டணங்கள்',
    systemLogs: 'அமைப்பு பதிவுகள்',
    botManagement: 'போட் மேலாண்மை',
    totalReceipts: 'மொத்த ரசீதுகள்',
    totalAmount: 'மொத்த தொகை',
    pendingReview: 'மதிப்பாய்வு நிலுவை',
    verified: 'சரிபார்க்கப்பட்டது',
    recentReceipts: 'சமீபத்திய ரசீதுகள்',
    merchant: 'வணிகர்',
    date: 'தேதி',
    amount: 'தொகை',
    status: 'நிலை',
    actions: 'செயல்கள்',
    view: 'பார்',
    edit: 'திருத்து',
    delete: 'நீக்கு',
    profileSettings: 'சுயவிவர அமைப்புகள்',
    darkMode: 'இருண்ட பயன்முறை',
    language: 'மொழி',
    save: 'சேமி',
    cancel: 'ரத்து',
    handsFree: 'ஹேண்ட்ஸ் ஃப்ரீ',
    sendMessage: 'செய்தி அனுப்பு',
    taxCenter: 'வரி மையம்',
    verifiedReportingManaged: 'Lyt Brox Pte Ltd. மூலம் சரிபார்க்கப்பட்ட அறிக்கை நிர்வகிக்கப்படுகிறது.',
    exportIRASSummary: 'IRAS சுருக்கத்தை ஏற்றுமதி செய்',
    fiscalEnvironment: 'நிதிச் சூழல்',
    financialYear: 'நிதியாண்டு',
    totalVerifiedBusinessDeductions: 'மொத்த சரிபார்க்கப்பட்ட வணிகக் குறைப்புகள்',
    totalInputTax: 'மொத்த உள்ளீட்டு வரி (GST)',
    eligibleRecords: 'தகுதியான பதிவுகள்',
    complianceVerified: 'இணக்கம் சரிபார்க்கப்பட்டது',
    filingStatus: 'தாக்கல் நிலை',
    lytspeedAuditMessage: 'Lytspeed உங்கள் பதிவுகளை சிங்கப்பூர் வரி தரங்களுக்கு எதிராக Lyt Brox Pte Ltd.க்காக தணிக்கை செய்துள்ளது.',
    taxRate: 'வரி விகிதம்',
    dataIntegrity: 'தரவு ஒருமைப்பாடு',
    auditExport: 'தணிக்கை ஏற்றுமதி',
    taxCategoryDistribution: 'வரி வகை விநியோகம்',
    deductible: 'குறைக்கத்தக்கது',
    records: 'பதிவுகள்',
    verifiedRecords: 'சரிபார்க்கப்பட்ட பதிவுகள்',
    category: 'வகை',
    noCategoriesFound: 'வகைகள் எதுவும் கிடைக்கவில்லை',
    noVerifiedRecordsFound: 'சரிபார்க்கப்பட்ட பதிவுகள் எதுவும் கிடைக்கவில்லை',
    searchVerifiedRecords: 'சரிபார்க்கப்பட்ட பதிவுகளைத் தேடு...',
  },
  ar: {
    dashboard: 'لوحة القيادة',
    taxReports: 'التقارير الضريبية',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    superAdmin: 'المسؤول الأعلى',
    teamLeader: 'قائد الفريق',
    normalUser: 'مستخدم عادي',
    receipts: 'الإيصالات',
    users: 'المستخدمون',
    businesses: 'الشركات',
    payments: 'المدفوعات',
    systemLogs: 'سجلات النظام',
    botManagement: 'إدارة البوت',
    totalReceipts: 'إجمالي الإيصالات',
    totalAmount: 'المبلغ الإجمالي',
    pendingReview: 'قيد المراجعة',
    verified: 'تم التحقق',
    recentReceipts: 'الإيصالات الأخيرة',
    merchant: 'التاجر',
    date: 'التاريخ',
    amount: 'المبلغ',
    status: 'الحالة',
    actions: 'الإجراءات',
    view: 'عرض',
    edit: 'تحرير',
    delete: 'حذف',
    profileSettings: 'إعدادات الملف الشخصي',
    darkMode: 'الوضع الداكن',
    language: 'اللغة',
    save: 'حفظ',
    cancel: 'إلغاء',
    handsFree: 'التحكم الصوتي',
    sendMessage: 'إرسال رسالة',
    taxCenter: 'مركز الضرائب',
    verifiedReportingManaged: 'التقارير المعتمدة تديرها Lyt Brox Pte Ltd.',
    exportIRASSummary: 'تصدير ملخص IRAS',
    fiscalEnvironment: 'البيئة المالية',
    financialYear: 'السنة المالية',
    totalVerifiedBusinessDeductions: 'إجمالي الخصومات التجارية المعتمدة',
    totalInputTax: 'إجمالي ضريبة المدخلات (GST)',
    eligibleRecords: 'السجلات المؤهلة',
    complianceVerified: 'تم التحقق من الامتثال',
    filingStatus: 'حالة التقديم',
    lytspeedAuditMessage: 'قامت Lytspeed بتدقيق سجلاتك مقابل معايير الضرائب السنغافورية لـ Lyt Brox Pte Ltd.',
    taxRate: 'معدل الضريبة',
    dataIntegrity: 'سلامة البيانات',
    auditExport: 'تصدير التدقيق',
    taxCategoryDistribution: 'توزيع فئة الضرائب',
    deductible: 'قابل للخصم',
    records: 'سجلات',
    verifiedRecords: 'السجلات المعتمدة',
    category: 'الفئة',
    noCategoriesFound: 'لم يتم العثور على فئات',
    noVerifiedRecordsFound: 'لم يتم العثور على سجلات معتمدة لـ',
    searchVerifiedRecords: 'البحث في السجلات المعتمدة...',
  },
  ja: {
    dashboard: 'ダッシュボード',
    taxReports: '税務報告',
    settings: '設定',
    logout: 'ログアウト',
    superAdmin: 'スーパー管理者',
    teamLeader: 'チームリーダー',
    normalUser: '一般ユーザー',
    receipts: 'レシート',
    users: 'ユーザー',
    businesses: 'ビジネス',
    payments: '支払い',
    systemLogs: 'システムログ',
    botManagement: 'ボット管理',
    totalReceipts: '総レシート数',
    totalAmount: '総額',
    pendingReview: 'レビュー保留中',
    verified: '確認済み',
    recentReceipts: '最近のレシート',
    merchant: '販売店',
    date: '日付',
    amount: '金額',
    status: 'ステータス',
    actions: 'アクション',
    view: '表示',
    edit: '編集',
    delete: '削除',
    profileSettings: 'プロフィール設定',
    darkMode: 'ダークモード',
    language: '言語',
    save: '保存',
    cancel: 'キャンセル',
    handsFree: 'ハンズフリー',
    sendMessage: 'メッセージを送信',
    taxCenter: '税務センター',
    verifiedReportingManaged: 'Lyt Brox Pte Ltd.によって管理された検証済みレポート。',
    exportIRASSummary: 'IRASサマリーをエクスポート',
    fiscalEnvironment: '財政環境',
    financialYear: '会計年度',
    totalVerifiedBusinessDeductions: '検証済みビジネス控除の合計',
    totalInputTax: '総仕入税額（GST）',
    eligibleRecords: '適格記録',
    complianceVerified: 'コンプライアンス検証済み',
    filingStatus: '申告ステータス',
    lytspeedAuditMessage: 'Lytspeedは、Lyt Brox Pte Ltd.のためにシンガポールの税基準に対してあなたの記録を監査しました。',
    taxRate: '税率',
    dataIntegrity: 'データ整合性',
    auditExport: '監査エクスポート',
    taxCategoryDistribution: '税カテゴリー分布',
    deductible: '控除可能',
    records: '記録',
    verifiedRecords: '検証済み記録',
    category: 'カテゴリー',
    noCategoriesFound: 'カテゴリーが見つかりません',
    noVerifiedRecordsFound: '検証済み記録が見つかりません',
    searchVerifiedRecords: '検証済み記録を検索...',
  },
  de: {
    dashboard: 'Dashboard',
    taxReports: 'Steuerberichte',
    settings: 'Einstellungen',
    logout: 'Abmelden',
    superAdmin: 'Super-Administrator',
    teamLeader: 'Teamleiter',
    normalUser: 'Normaler Benutzer',
    receipts: 'Belege',
    users: 'Benutzer',
    businesses: 'Unternehmen',
    payments: 'Zahlungen',
    systemLogs: 'Systemprotokolle',
    botManagement: 'Bot-Verwaltung',
    totalReceipts: 'Gesamtbelege',
    totalAmount: 'Gesamtbetrag',
    pendingReview: 'Überprüfung ausstehend',
    verified: 'Verifiziert',
    recentReceipts: 'Letzte Belege',
    merchant: 'Händler',
    date: 'Datum',
    amount: 'Betrag',
    status: 'Status',
    actions: 'Aktionen',
    view: 'Ansehen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    profileSettings: 'Profileinstellungen',
    darkMode: 'Dunkler Modus',
    language: 'Sprache',
    save: 'Speichern',
    cancel: 'Abbrechen',
    handsFree: 'Freihändig',
    sendMessage: 'Nachricht senden',
    taxCenter: 'Steuerzentrum',
    verifiedReportingManaged: 'Verifizierte Berichterstattung verwaltet von Lyt Brox Pte Ltd.',
    exportIRASSummary: 'IRAS-Zusammenfassung exportieren',
    fiscalEnvironment: 'Steuerumgebung',
    financialYear: 'Geschäftsjahr',
    totalVerifiedBusinessDeductions: 'Gesamte verifizierte Betriebsausgaben',
    totalInputTax: 'Gesamtvorsteuer (GST)',
    eligibleRecords: 'Berechtigte Aufzeichnungen',
    complianceVerified: 'COMPLIANCE VERIFIZIERT',
    filingStatus: 'Einreichungsstatus',
    lytspeedAuditMessage: 'Lytspeed hat Ihre Aufzeichnungen nach singapurischen Steuerstandards für Lyt Brox Pte Ltd. geprüft.',
    taxRate: 'Steuersatz',
    dataIntegrity: 'Datenintegrität',
    auditExport: 'PRÜFEXPORT',
    taxCategoryDistribution: 'Steuerkategorieverteilung',
    deductible: 'Abzugsfähig',
    records: 'Aufzeichnungen',
    verifiedRecords: 'Verifizierte Aufzeichnungen',
    category: 'Kategorie',
    noCategoriesFound: 'Keine Kategorien gefunden',
    noVerifiedRecordsFound: 'Keine verifizierten Aufzeichnungen gefunden für',
    searchVerifiedRecords: 'Verifizierte Aufzeichnungen suchen...',
  },
  ko: {
    dashboard: '대시보드',
    taxReports: '세금 보고서',
    settings: '설정',
    logout: '로그아웃',
    superAdmin: '슈퍼 관리자',
    teamLeader: '팀 리더',
    normalUser: '일반 사용자',
    receipts: '영수증',
    users: '사용자',
    businesses: '사업',
    payments: '결제',
    systemLogs: '시스템 로그',
    botManagement: '봇 관리',
    totalReceipts: '총 영수증',
    totalAmount: '총액',
    pendingReview: '검토 대기 중',
    verified: '확인됨',
    recentReceipts: '최근 영수증',
    merchant: '판매자',
    date: '날짜',
    amount: '금액',
    status: '상태',
    actions: '작업',
    view: '보기',
    edit: '편집',
    delete: '삭제',
    profileSettings: '프로필 설정',
    darkMode: '다크 모드',
    language: '언어',
    save: '저장',
    cancel: '취소',
    handsFree: '핸즈프리',
    sendMessage: '메시지 보내기',
    taxCenter: '세무 센터',
    verifiedReportingManaged: 'Lyt Brox Pte Ltd.에서 관리하는 검증된 보고.',
    exportIRASSummary: 'IRAS 요약 내보내기',
    fiscalEnvironment: '재정 환경',
    financialYear: '회계 연도',
    totalVerifiedBusinessDeductions: '총 검증된 사업 공제',
    totalInputTax: '총 매입세액 (GST)',
    eligibleRecords: '적격 기록',
    complianceVerified: '규정 준수 확인됨',
    filingStatus: '신고 상태',
    lytspeedAuditMessage: 'Lytspeed는 Lyt Brox Pte Ltd.를 위해 싱가포르 세금 기준에 따라 귀하의 기록을 감사했습니다.',
    taxRate: '세율',
    dataIntegrity: '데이터 무결성',
    auditExport: '감사 내보내기',
    taxCategoryDistribution: '세금 카테고리 분포',
    deductible: '공제 가능',
    records: '기록',
    verifiedRecords: '검증된 기록',
    category: '카테고리',
    noCategoriesFound: '카테고리를 찾을 수 없음',
    noVerifiedRecordsFound: '검증된 기록을 찾을 수 없음',
    searchVerifiedRecords: '검증된 기록 검색...',
  },
};

export function getTranslation(lang: string, key: string): string {
  const langTranslations = translations[lang as keyof typeof translations];
  if (!langTranslations) return key;
  return langTranslations[key as keyof typeof langTranslations] || key;
}

export const languages = [
  { code: 'en', name: 'English' },
  { code: 'zh', name: '中文' },
  { code: 'ms', name: 'Bahasa Melayu' },
  { code: 'ta', name: 'தமிழ்' },
  { code: 'ar', name: 'العربية' },
  { code: 'ja', name: '日本語' },
  { code: 'de', name: 'Deutsch' },
  { code: 'ko', name: '한국어' },
];
